import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import CookieBanner from "@/components/CookieBanner";
import VacationOverlay from "@/components/VacationOverlay";
import Home from "@/pages/Home";
import Inventory from "@/pages/Inventory";
import VehicleDetail from "@/pages/VehicleDetail";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPhotoStudio from "@/pages/AdminPhotoStudio";
import AdminVacation from "@/pages/AdminVacation";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/fahrzeuge" element={<Layout><Inventory /></Layout>} />
            <Route path="/fahrzeuge/:id" element={<Layout><VehicleDetail /></Layout>} />
            <Route path="/ueber-uns" element={<Layout><About /></Layout>} />
            <Route path="/kontakt" element={<Layout><Contact /></Layout>} />
            <Route path="/impressum" element={<Layout><Impressum /></Layout>} />
            <Route path="/datenschutz" element={<Layout><Datenschutz /></Layout>} />
            <Route path="/agb" element={<Layout><AGB /></Layout>} />
            <Route path="/admin/login" element={<Layout><AdminLogin /></Layout>} />
            <Route path="/admin" element={<Layout><AdminDashboard /></Layout>} />
            <Route path="/admin/foto-studio" element={<Layout><AdminPhotoStudio /></Layout>} />
            <Route path="/admin/betriebsurlaub" element={<Layout><AdminVacation /></Layout>} />
          </Routes>
          <CookieBanner />
          <VacationOverlay />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
